module.exports = __webpack_public_path__ + "img/1x.0a7e7ca.jpg";